import React, { memo } from "react";
import { Table, TableProps } from "@mui/material";

const AppTable = ({ children, ...otherProps }: TableProps) => {
  return (
    <Table className="table border-separate" {...otherProps}>
      {children}
    </Table>
  );
};

export default memo(AppTable);
